import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./app";
import FontStyles from "./assets/css/fonts";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <FontStyles />
    <App />
  </React.StrictMode>
);
